module.exports = __webpack_public_path__ + "static/media/YM46_8.25305958.jpg";